import * as classnames from 'classnames/bind'
import Article from 'entities/article'
import Group from 'entities/group'
import * as React from 'react'
import { FC } from 'react'
import { isEmpty } from 'lodash'
import { updateUrlQuery } from 'utilities/url_util'
import styles from './article_cards.module.scss'

const cx = classnames.bind(styles)

type Props = {
  articles: [typeof Article]
  className: string | null
  cardClassName: string | null
  groups: typeof Group
  cid: string | null
}

const ArticleCards: FC<Props> = ({ articles, cardClassName, className, cid }) => {
  if (isEmpty(articles)) {
    return null
  }

  return (
    <div className={cx(className, styles.cards)}>
      {articles
        .map(article => new Article(article))
        .map(article => {
          const { cover, id, summary, title, url } = article
          const coverStyle = cover.thumb.url ? { backgroundImage: `url(${cover.thumb.url})` } : null

          return (
            <a
              key={id}
              href={cid === null ? url : updateUrlQuery(url, 'cid', cid)}
              className={cx(cardClassName, styles.card)}
            >
              <div className={styles.cover} style={coverStyle} />
              <div className={styles.headline}>
                <div className={styles.title}>{title}</div>
                <div className={styles.summary}>{summary}</div>
              </div>
            </a>
          )
        })}
    </div>
  )
}

export default ArticleCards
